import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "@maplibre/maplibre-gl-leaflet";
import "leaflet/dist/leaflet.css";
import "maplibre-gl/dist/maplibre-gl.css";

// Mapa base vectorial gratuito de OpenFreeMap (estilos: positron, bright, liberty, dark, fiord)
const BaseMapLayer = ({ mapStyle = "positron" }) => {
    const map = useMap();

    useEffect(() => {
        const layer = L.maplibreGL({
            style: `https://tiles.openfreemap.org/styles/${mapStyle}`,
            attribution: '<a href="https://openfreemap.org">OpenFreeMap</a> &copy; <a href="https://www.openmaptiles.org/">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        });
        layer.addTo(map);
        return () => map.removeLayer(layer);
    }, [map, mapStyle]);

    return null;
};

export default BaseMapLayer;
